import Router from "./components/router/Router";
import { ToastProvider } from "./providers/ToastProvider";

function App() {
  return (
    <div className="font-sans">
      <ToastProvider>
        <Router />
      </ToastProvider>
    </div>
  );
}

export default App;
